import {
  createContext,
  type FC,
  type PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react'

export interface MobileMenu {
  isOpen: boolean
  open: () => void
  close: () => void
}

const MobileMenuContext = createContext<MobileMenu | null>(null)

export const MobileMenuProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)

  const menu = useMemo(
    (): MobileMenu => ({
      isOpen,
      open: () => {
        setIsOpen(true)
      },
      close: () => {
        setIsOpen(false)
      },
    }),
    [isOpen],
  )

  return <MobileMenuContext.Provider value={menu}>{children}</MobileMenuContext.Provider>
}

export const useMobileMenu = (): MobileMenu | null => useContext(MobileMenuContext)
